export default __webpack_public_path__ + "static/who-we-are-477d4d1d01c5c567d02528c224b75aed.jpg";